import { Platform } from "react-native-web";
const getTzaEnvContext = env => {
  const clientType = Platform.OS === "web" ? "Web" : "Mobile";
  return env.replace("development", "local") + clientType;
};
export { getTzaEnvContext };
//# sourceMappingURL=env-definition.mjs.map
